import { createAsyncThunk } from '@reduxjs/toolkit';

import { KhodroHttpGetService } from 'Feature/Khodro/ShakhsSales/Services/KhodroHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import IGetAllMoredEstefadehHayeKhodroByNoeVasilehNaghliehQuery from '../Queries/IGetAllMoredEstefadehHayeKhodroByNoeVasilehNaghliehQuery';

export const getAllMoredEstefadehHayeKhodroByNoeVasilehNaghlieh = createAsyncThunk(
  'MoredEstefadehKhodro/GetAllMoredEstefadehHayeKhodroByNoeVasilehNaghlieh',
  async (query: IGetAllMoredEstefadehHayeKhodroByNoeVasilehNaghliehQuery) => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.MoredEstefadehKhodro.GetAllMoredEstefadehHayeKhodroByNoeVasilehNaghlieh}`,
      params: query,
    });
  }
);
